import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, IconButton } from '@material-ui/core';
import { ChevronLeftRounded, ChevronRightRounded, FirstPageRounded, LastPageRounded } from '@material-ui/icons';
 
class Pagination extends Component {
    static propTypes = {
        items: PropTypes.array.isRequired,
        onChangePage: PropTypes.func.isRequired,
        initialPage: PropTypes.number,
        pageSize: PropTypes.number
    };
    static defaultProps = {
        initialPage: 1,
        pageSize: 15,
    };
    state = {
        pager: {},
    };
 
    componentWillMount() {
        // set page if items array isn't empty
        
        if (this.props.items) {
            this.setPage(this.props.initialPage);
        }
    }
 
    setPage = page => {        
        var { items, pageSize } = this.props;
        var pager = this.state.pager; 

        // console.log('aze 1', pager.totalPages);
        if (page < 1 || page > pager.totalPages) {
            page = 1;
        }
        // console.log('aze 2');

        // get new pager object for specified page
        pager = this.getPager(items.length, page, pageSize);
        
        // get new page of items from items array
        var pageOfItems = items.slice(pager.startIndex, pager.endIndex + 1);
 
        // update state
        this.setState({ pager: pager });
        // console.log('Page of Items in Pagination : ', pageOfItems);
        // call Click page function in parent component
        this.props.onChangePage(pageOfItems, page);
        // console.log('PAGE ITEMS : ', pageOfItems);
    }
 
    getPager = (totalItems, currentPage, pageSize) => {
        // default to first page
        currentPage = currentPage || 1;
 
        // default page size is 10
        pageSize = pageSize || 10;
 
        // calculate total pages
        var totalPages = Math.ceil(totalItems / pageSize);
        if (!totalPages) totalPages = 1;
 
        var startPage, endPage;
        if (totalPages <= 5) {
            // less than 5 total pages so show all
            startPage = 1;
            endPage = totalPages;
        } else {
            // more than 10 total pages so calculate start and end pages
            if (currentPage <= 3) {
                startPage = 1;
                endPage = 5;
            } else if (currentPage + 2 >= totalPages) {
                startPage = totalPages - 4;
                endPage = totalPages;
            } else {
                startPage = currentPage - 2;
                endPage = currentPage + 2;
            }
        }
 
        // calculate start and end item indexes
        var startIndex = (currentPage - 1) * pageSize;
        var endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);
 
        // create an array of pages to ng-repeat in the pager control
        var pages = [...Array((endPage + 1) - startPage).keys()].map(i => startPage + i);
 
        // return object with all pager properties required by the view
        return {
            totalItems: totalItems,
            currentPage: currentPage,
            pageSize: pageSize,
            totalPages: totalPages,
            startPage: startPage,
            endPage: endPage,
            startIndex: startIndex,
            endIndex: endIndex,
            pages: pages
        };
    }
 
    render() {
        var pager = this.state.pager;
        
        if (!pager.pages || pager.pages.length <= 1) {
            // don't display pager if there is only 1 page
            return null;
        }
 
        return (
            <Box>

            {/* <ul className="pagination fw-footer pagination wizard">
                <li className={pager.currentPage === 1 ? 'disabled' : 'previous first'}>
                    <a onClick={() => this.setPage(1)}>
                        <i className="zmdi zmdi-more-horiz"></i>
                    </a>
                </li>
                <li className={pager.currentPage === 1 ? 'disabled' : 'previous'}>
                    <a onClick={() => this.setPage(pager.currentPage - 1)}>
                        <i className="zmdi zmdi-chevron-left"></i>
                    </a>
                </li>

                {pager.pages.map((page, index) =>
                    <li key={index} className={pager.currentPage === page ? 'active' : ''}>
                        <a onClick={() => this.setPage(page)}>{page}</a>
                    </li>
                )}

                <li className={pager.currentPage === pager.totalPages ? 'disabled' : 'next'}>
                    <a onClick={() => this.setPage(pager.currentPage + 1)}>
                        <i className="zmdi zmdi-chevron-right"></i>
                    </a>
                </li>
                <li className={pager.currentPage === pager.totalPages ? 'disabled' : 'next last'}>
                    <a onClick={() => this.setPage(pager.totalPages)}>
                        <i className="zmdi zmdi-more-horiz"></i>
                    </a>
                </li>

            </ul> */}
                <IconButton color="secondary" onClick={() => this.setPage(1)} disabled={pager.currentPage === 1}>
                    <FirstPageRounded />
                </IconButton>
                <IconButton color="secondary" onClick={() => this.setPage(pager.currentPage - 1)} disabled={pager.currentPage === 1}>
                    <ChevronLeftRounded />
                </IconButton>
                
                {pager.pages.map((page, index) =>                        
                    <Button key={index} onClick={() => this.setPage(page)} color={pager.currentPage === page ? 'secondary' : 'default'}>
                        {page}
                    </Button>
                )}

                <IconButton disabled={pager.currentPage === pager.totalPages} color="secondary" onClick={() => this.setPage(pager.currentPage + 1)}>
                    <ChevronRightRounded />
                </IconButton>
                <IconButton disabled={pager.currentPage === pager.totalPages} color="secondary" onClick={() => this.setPage(pager.totalPages)}>
                    <LastPageRounded />
                </IconButton>
            </Box>
        );
    }
}

export default Pagination

